import { useState } from "react";
import { getCurrentDate } from "../lib/formatter/Formatter";
import { partners } from "../lib/interfaces/IPartnerInterface";

const useReport = () => {
  const [dates, setDate] = useState(getCurrentDate());
  const [todate, setToDate] = useState("");
  const [fromdate, setFromDate] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [partners, setPartners] = useState<partners[] | null>(null);
  const [selectedpartner, setSelectedPartner] = useState("");

  return {
    dates,
    selectedOption,
    setDate,
    setToDate,
    setFromDate,
    setSelectedOption,
    setPartners,
    setSelectedPartner,
  };
};
export default useReport;
